module.exports = __webpack_public_path__ + "static/media/alert.2d4d2153.ogg";